



























































import ContactSelect from "../../core/Forms/ContactSelect.vue";
import { Contact } from "../../models/Contact";
import { RecurrenceIntervention } from "../../models/RecurrenceIntervention";
import TextInput from "../../core/Forms/TextInput.vue";
import CheckboxInput from "../../core/Forms/CheckboxInput.vue";

export default {
    name: "RecurrenceInterventionsSecondairesEdit",
    components: {
        CheckboxInput,
        TextInput,
        ContactSelect,
    },
    props: {
        recurrenceIntervention: RecurrenceIntervention,
    },
    data() {
        return {
            clientUnique: false,
            contactSelectFilters: [
                Contact.EType.Copropriete,
                Contact.EType.Bureau,
                Contact.EType.Particulier,
            ],
        };
    },
    created() {
        if (
            !_.some(
                this.recurrenceIntervention.interventions_secondaires,
                function (interventionSecondaire) {
                    return interventionSecondaire.client_id;
                }
            )
        ) {
            this.clientUnique = true;
        }
    },
    methods: {
        addInterventionSecondaire() {
            this.recurrenceIntervention.interventions_secondaires.push(
                new RecurrenceIntervention.InterventionSecondaire({
                    description: this.recurrenceIntervention.titre,
                })
            );
        },
        deleteInterventionSecondaire(
            interventionSecondaire: RecurrenceIntervention.InterventionSecondaire
        ) {
            _.first(
                _.remove(
                    this.recurrenceIntervention.interventions_secondaires,
                    {
                        __uniqueid: interventionSecondaire.__uniqueid,
                    }
                )
            );
            this.$forceUpdate();
        },
    },
    watch: {
        clientUnique: function () {
            if (this.clientUnique) {
                _.each(
                    this.recurrenceIntervention.interventions_secondaires,
                    function (interventionSecondaire) {
                        interventionSecondaire.client = null;
                    }
                );
            }
        },
    },
};
